import * as React from "react";
import "./Heading2.scss";

export const Heading2: React.FC<{ text: string; className?: string }> = ({
  text,
  className = "",
}) => {
  return <h2 className={`heading-2 ${className}`}>{text}</h2>;
};
